module.exports = __webpack_public_path__ + "static/media/go_holidays_logo.3a7adc09.png";